<template>
  <article class="order-details">
    <h2 ref="heading" tabindex="-1">Замовлення №{{ order.id }}</h2>
    <p>{{ orderDate(order.date) }}</p>
    <p>Статус замовлення: <strong>{{ orderStatus(order.status) }}</strong></p>
    <p>Оплата: <strong>{{ orderPayment(order.payment_status) }}</strong></p>
    <p v-if="order.payment_status === 'pending'" class="notice">Оплату цього замовлення ще не підтверджено. Цей запис не означає успішну покупку.</p>
    <p v-else-if="order.payment_status === 'refunded'" class="notice">Для цього замовлення зафіксовано повернення балів.</p>
    <p v-else-if="order.payment_status !== 'paid'" class="notice">Підтвердження оплати в історії відсутнє.</p>
    <h3>Винагороди</h3>
    <ul class="reward-list">
      <li v-for="item in order.items" :key="item.id">
        <strong>{{ item.name }}</strong>
        <span v-if="item.type">{{ item.type === 'physical' ? 'Фізична винагорода' : 'Цифрова винагорода' }}</span>
        <span>{{ item.quantity }} шт. × {{ orderPoints(item.price) }}</span>
        <span>Сума позиції: {{ orderPoints(item.total) }}</span>
      </li>
    </ul>
    <p v-if="!order.items.length">Позиції замовлення недоступні.</p>
    <p class="catalog-note">Назви й типи винагород наведені за поточним каталогом; кількість і ціни — із замовлення.</p>
    <p><strong>Сума замовлення: {{ orderPoints(order.total) }}</strong></p>
    <template v-if="order.receipt">
      <p>Фактично списано: {{ orderPoints(order.receipt.charged_points) }}</p>
      <p>Баланс після цієї покупки: {{ orderPoints(order.receipt.balance_after) }}</p>
    </template>
    <p v-else-if="order.payment_status === 'paid'">Дані про фактичне списання недоступні.</p>
    <h3>Реквізити отримання</h3>
    <p v-if="!order.receiving.methods.length">Спосіб отримання ще не зазначено.</p>
    <ul v-else>
      <li v-for="method in order.receiving.methods" :key="method">{{ receivingLabel(method) }}</li>
    </ul>
    <p v-if="order.receiving.name">{{ order.receiving.name }}</p>
    <p v-if="order.receiving.phone">Телефон: {{ order.receiving.phone }}</p>
    <p v-if="order.receiving.city">{{ order.receiving.city }}</p>
    <p v-if="order.receiving.branch">{{ order.receiving.branch }}</p>
    <p v-if="order.receiving.email">Email: {{ order.receiving.email }}</p>
  </article>
</template>
<script>
import { orderDate, orderStatus, orderPayment, orderPoints } from "../resources/js/helpers/orderHistory";
export default {
  props: { order: { type: Object, required: true } },
  methods: {
    orderDate, orderStatus, orderPayment, orderPoints,
    receivingLabel(method) { return { np: "Нова Пошта", email: "Електронна пошта", representative: "Через представника" }[method] || method; },
    focusTitle() { this.$refs.heading.focus(); },
  },
};
</script>
<style scoped>
.order-details { background: #fff; padding: 16px; border-radius: 8px; overflow-wrap: anywhere; }
h2 { font-size: 22px; } h3 { font-size: 18px; margin: 24px 0 12px; }
p { margin: 12px 0; line-height: 1.5; }
.notice { padding: 12px; background: #fff3df; color: #684814; }
.reward-list { list-style: none; padding: 0; }
.reward-list li { display: grid; gap: 8px; padding: 16px 0; border-bottom: 1px solid #ddd; }
.catalog-note { color: #555; font-size: 14px; }
</style>
